import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

Vue.config.productionTip = false;
import preview from "vue-photo-preview";
import "vue-photo-preview/dist/skin.css";
import VueVaptcha from './components/common/Vaptcha/index';

Vue.use(VueVaptcha({
    vid: '61a8d772207a2a574b4493c9'
}));
let options = {
  fullscreenEl: false
};
Vue.use(preview, options);
Vue.use(preview);
const vue = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
export default vue;
